import React from "react";
import GoBack from "shared/ui/GoBack";
import MyGiftsList from "widgets/MyGiftsList";

const MyGifts: React.FC = () => {
  return (
    <main>
      <GoBack black />

      <MyGiftsList />
    </main>
  );
};

export default MyGifts;
